import { FC, useEffect } from 'react';

import cpcFlexibleDailyBudgetButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_daily_budget_button_click';
import { Link, VSpacing } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import useIsNewCampaign from 'utils/campaign/hooks/useIsNewCampaign';

import { DailyBudget } from 'components/CpcFlexibleCreate/CpcForm/AdBudget/DailyBudget/DailyBudget';
import { TotalBudget } from 'components/CpcFlexibleCreate/CpcForm/AdBudget/TotalBudget/TotalBudget';

import { setCampaignDailyBudget } from 'store/models/createCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    setDailyBudget: 'AdCreate.AdForm.adTotalBudget.setDailyBudget',
    switchOffDailyBudget: 'AdCreate.AdForm.AdDailyBudget.switchOff',
};

export const AdBudget: FC = () => {
    const { adDailyBudget } = useSelector((state) => state.createCampaign);
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const isCampaignCreateProcess = useIsNewCampaign();
    const [isShownDailyBudget, setShowDailyBudget, setHideDailyBudget] = useOnOffState(false);

    const dispatch = useDispatch();
    const trl = useTrls();

    const onSwitchOnDailyBudget = () => {
        if (isCampaignCreateProcess) {
            cpcFlexibleDailyBudgetButtonClick({ vacancyId });
        }
        setShowDailyBudget();
    };

    const onSwitchOffDailyBudget = () => {
        setHideDailyBudget();
        dispatch(setCampaignDailyBudget(null));
    };

    useEffect(() => {
        if (adDailyBudget) {
            setShowDailyBudget();
        }
    }, [adDailyBudget, setShowDailyBudget]);

    return (
        <>
            <TotalBudget />
            {isShownDailyBudget && (
                <>
                    <VSpacing default={24} />
                    <DailyBudget />
                </>
            )}
            <VSpacing default={12} />
            <Link
                Element="button"
                enableVisited={false}
                onClick={isShownDailyBudget ? onSwitchOffDailyBudget : onSwitchOnDailyBudget}
            >
                {isShownDailyBudget ? trl(TrlKeys.switchOffDailyBudget) : trl(TrlKeys.setDailyBudget)}
            </Link>
        </>
    );
};
